<mat-dialog-content class="mat-dialog-content--launch" data-testid="cy-launch-scope">
    <img src="assets/images/launch-scope.png" aria-hidden="true" alt="Logo Scope" />

    <h2 mat-dialog-title i18n="@@runtime-installed-title">Scope Runtime downloaded and installed?</h2>

    <p i18n="@@runtime-installed-description">That’s awesome. Now you are set to launch Scope.</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button class="riege-button" mat-flat-button mat-dialog-close i18n="@@button-label-close">Close</button>

    <button
        mat-flat-button
        color="primary"
        class="riege-button launch_scope"
        (click)="doLaunchScope.emit()"
        i18n="@@button-label-launch-app"
        >Launch app</button
    >
</mat-dialog-actions>
